import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import uuidv4 from 'uuid/v4'

const endpoint = `${apiUrl.stable}/extrato`

/**
 * Makes a credit card recharge of an specific amount
 * @param {Number} amount - How much brazilian reais should be recharged
 * @param {Number} creditCardId - The ID of the card that should be charged
 */
export const rechargeWithCreditCard = (amount, creditCardId, shouldProgramAutomaticRecharge, paymentType?, companyQuotationId?, connectionId?) => {
  const url = `${endpoint}/recargacomcartao`
  let postData = { amount, creditCardId, shouldProgramAutomaticRecharge, paymentType, companyQuotationId, connectionId }

  let axiosConfig = {
    headers: {
      ...jsonWebToken.header,
      'x-requestid': uuidv4()
    }
  }

  return axios.post(url, postData, axiosConfig)
}

/**
 * Generate a invoice of an specific amount in Brazilian's Boleto
 * @param {Number} amount - How much brazilian reais should be recharged
 * @returns {Promise.<{ data: ApiWalletBoletoRecharge }>}
 */
export const rechargeWithBoleto = (amount) => {
  const url = `${endpoint}/recargacomboleto`
  let postData = { amount }

  let axiosConfig = {
    headers: {
      ...jsonWebToken.header,
      'x-requestid': uuidv4()
    }
  }

  return axios.post(url, postData, axiosConfig)
}


/**
 * Generate a invoice of an specific amount in Brazilian's Boleto
 * @param {Number} amount - How much brazilian reais should be recharged
 * @returns {Promise.<{ data: ApiWalletBoletoRecharge }>}
 */
 export const rechargeWithPix = (amount, paymentType?, companyQuotationId?, connectionId?) => {
  const url = `${endpoint}/recargacompix`
  let postData = { amount, paymentType,  companyQuotationId, connectionId}

  let axiosConfig = {
    headers: {
      ...jsonWebToken.header,
      'x-requestid': uuidv4()
    }
  }

  return axios.post(url, postData, axiosConfig)
}

/**
 * Returns a list with pending transactions made with Brazilian's Boleto
 * @returns {Promise.<{ data: ApiWalletBoletoPending[] }>}
 */
export const getPendingBoletos = () => {
  const url = `${endpoint}/boletos`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

export const getPendingPix = () => {
  const url = `${endpoint}/pix`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

export default {
  rechargeWithCreditCard,
  rechargeWithBoleto,
}